import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Text from "@mui/material/Typography";
// import { Text } from "@imminently/react/ui/core/text";
import { useAuth } from "react-oidc-context";
import { Theme } from "@/theme";
import { useEffect } from "react";
import { useConfigContext } from "@imminently/react/context/config";


const styles = {
  button: {
    textTransform: "uppercase",
    width: 150,
    alignSelf: "center",
    mt: 4,
  }
};

export const Landing = () => {
  const { signinRedirect, isLoading, isAuthenticated, user } = useAuth();
  const config = useConfigContext();

  const signin = () => {
    signinRedirect();
  };

  // Auto-redirect to sign-in if not authenticated and not loading
  useEffect(() => {
    const noAuth = config.auth.type === "none";
    
    console.log("[Landing] Auth state:", { 
      isLoading, 
      isAuthenticated, 
      hasUser: !!user, 
      noAuth,
      authType: config.auth.type 
    });
    
    if (!noAuth && !isLoading && !isAuthenticated && !user) {
      console.log("[Landing] No user found, auto-redirecting to sign-in");
      signinRedirect();
    }
  }, [isLoading, isAuthenticated, user, signinRedirect, config.auth.type]);

  return (
    // <EmptyContent
    //   // image="/trier-full-horizontal-dark.svg"
    //   width="400px"
    // >
    <Box
      display="flex"
      position="relative"
      flexDirection="column"
      justifyContent="center"
      alignContent="center"
      alignItems="center"
      width="100%"
    >
      <Stack
        position="relative"
        direction="row"
        justifyContent="center"
        alignContent="center"
        alignItems="center"
      >
        <img
          style={{
            height: "80px",
            width: "80px",
          }}
          src="/trier-dark.svg"
        />
        <Text
          variant="h1"
          sx={(theme: Theme) => ({
            ml: 2,
            userSelect: "none",
            color: `${theme.palette.primary[500]}`,
          })}
        >
          My Emergency Visit
        </Text>
      </Stack>
      <Button sx={styles.button} onClick={signin}>
        sign in
      </Button>
    </Box>
    // </EmptyContent>
  );
};